import { ChangeDetectorRef, Component, ElementRef } from '@angular/core';

import { CmpsDecimalPipe, CmpsPercentPipe } from '../common/number.pipe';
import { MetricDataItem } from '../performance-data/metric.pd.model';

import { ConfigViewMetric, Metric } from './config.insight.model';
import { TranslationKeyMap } from './insight.i18n';
import {
    formatColumn,
    OptionalColumn,
    OptionalColumnType,
    valueForColumn,
} from './optional-column.insight.model';

@Component({
    selector: '[cmpsInsightRollover]',
    templateUrl: './rollover.insight.component.html',
})
export class RolloverInsightComponent {
    i18n = TranslationKeyMap;
    OptionalColumnType = OptionalColumnType;
    metric: Metric;
    private _viewMetric: ConfigViewMetric;
    private _dataMetric: MetricDataItem;
    private _peerGroupDataMetric: MetricDataItem;
    showThresholdColours: boolean;
    showTrendArrows: boolean;
    private _optionalColumns: OptionalColumn[];
    supportedColumns: OptionalColumn[];

    // eslint-disable-next-line accessor-pairs
    set viewMetric(value: ConfigViewMetric) {
        this._viewMetric = value;
        this.setSupportColumns();
    }

    get dataMetric(): MetricDataItem {
        return this._dataMetric;
    }

    set dataMetric(value: MetricDataItem) {
        this._dataMetric = value || ({} as any);
    }

    // eslint-disable-next-line accessor-pairs
    set peerGroupDataMetric(value: MetricDataItem) {
        this._peerGroupDataMetric = value || ({} as any);
    }

    // eslint-disable-next-line accessor-pairs
    set optionalColumns(value: OptionalColumn[]) {
        this._optionalColumns = value;
        this.setSupportColumns();
    }

    constructor(
        private readonly _el: ElementRef,
        private readonly _changeDetectorRef: ChangeDetectorRef,
        private readonly _decimalPipe: CmpsDecimalPipe,
        private readonly _percentPipe: CmpsPercentPipe,
    ) {}

    formatColumn(column: OptionalColumnType): any {
        return formatColumn(
            column,
            valueForColumn(
                column,
                column === OptionalColumnType.PEER_GROUP_ACTUAL ||
                    column === OptionalColumnType.PEER_GROUP_PERCENT_TO_TARGET
                    ? this._peerGroupDataMetric
                    : this._dataMetric,
            ),
            this._decimalPipe,
            this._percentPipe,
        );
    }

    private setSupportColumns(): void {
        // eslint-disable-next-line @typescript-eslint/prefer-includes
        this.supportedColumns =
            this._viewMetric &&
            this._optionalColumns &&
            this._optionalColumns.filter(
                // eslint-disable-next-line @typescript-eslint/prefer-includes
                (e) => this._viewMetric.supportedColumns.indexOf(e.id) !== -1,
            );
    }
}
